const API = process.env.REACT_APP_BACKEND_URL || "";

export function resolveImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${API}${url}`;
  return url;
}
